import React, { useEffect, useState } from 'react';
import CmsFlexBox from '../Models/CMS/CmsFlexBox';
import { useConfiguredSanitize } from '@ibe/components';
import FlexBoxUtils from '../Util/FlexBoxUtils';
import { QueryUtils } from '../Util/QueryUtils';
import useQuery from '../Util/useQuery';
import CollapseWrapper from '../Components/CollapseWrapper/CollapseWrapper';

interface Props {
  flexBoxes: CmsFlexBox[];
  className?: string;
  startDate?: string;
  alwaysDisplay?: boolean;
}

const FlexBox = (props: Props) => {
  const { className = '', flexBoxes, startDate, alwaysDisplay } = props;
  const query = useQuery();
  const { sanitize } = useConfiguredSanitize();

  const [flexBox, setFlexBox] = useState<CmsFlexBox | undefined>(undefined);
  const searchStart = startDate || QueryUtils.getSearchStartDate(query);

  useEffect(() => {
    if (alwaysDisplay) {
      setFlexBox(flexBoxes[0]);
    } else {
      if (searchStart) {
        const datedFlexbox = FlexBoxUtils.getDatedFlexBox(flexBoxes, searchStart);
        if (datedFlexbox) {
          setFlexBox(datedFlexbox);
          return;
        }
      }
      setFlexBox(FlexBoxUtils.getDefaultFlexBox(flexBoxes));
    }
  }, [searchStart]);

  return flexBox ? (
    <div
      className={'p-3 flexBoxContainer ' + className}
      style={flexBox.accentColor ? { borderLeftColor: flexBox.accentColor } : undefined}
    >
      <CollapseWrapper title={flexBox.header || ''} isOpen={flexBox.initiallyExpanded}>
        <div className="d-flex flex-column">
          <div dangerouslySetInnerHTML={{ __html: sanitize(flexBox.content || '', true) }} />
        </div>
      </CollapseWrapper>
    </div>
  ) : (
    <></>
  );
};

export default FlexBox;
